import { SxProps } from '@mui/material';
import type { Theme } from '@portals/core/src/themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => ({
  iconGreen: { fill: theme.palette.text.positive },
});
